export const parseWifiTelemetryPayload = (payload) => {
  if (!payload) {
    return null;
  }

  const parsedPayload = typeof payload === 'string' ? JSON.parse(payload) : payload;
  if (!parsedPayload || typeof parsedPayload !== 'object') {
    return null;
  }

  const temperature = parsedPayload.temperature ?? parsedPayload.temp ?? '';
  const pressure = parsedPayload.pressure ?? parsedPayload.press ?? '';
  const telemetry = parsedPayload.telemetry ?? parsedPayload.data ?? parsedPayload.value ?? '';
  const status = parsedPayload.status ?? 'Connected via Wi‑Fi';

  if (!temperature && !pressure && !telemetry) {
    return null;
  }

  return {
    temperature: temperature ? `${String(temperature).replace(/C$/i, '').trim()} C` : '',
    pressure: pressure ? `${String(pressure).replace(/hPa$/i, '').trim()} hPa` : '',
    telemetry: typeof telemetry === 'string' ? telemetry : JSON.stringify(telemetry),
    status
  };
};
